import { createFileRoute } from "@tanstack/react-router";
import { requerirEdicionDeSolicitud } from "@/features/solicitudes/utils/guard-edicion";
import { areasQueryOptions } from "@/features/catalogos/hooks/use-catalogos";
import { DatosGeneralesPage } from "@/features/datos-generales/components/DatosGeneralesPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";
import { DatosGeneralesSkeleton } from "@/features/datos-generales/components/DatosGeneralesSkeleton";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/datos-generales")({
  beforeLoad: requerirEdicionDeSolicitud,
  loader: ({ context: { queryClient }, params: { id } }) => Promise.all([queryClient.ensureQueryData(solicitudQueryOptions(id)), queryClient.ensureQueryData(areasQueryOptions)]),
  component: DatosGeneralesPage,
  pendingComponent: DatosGeneralesSkeleton,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
